import { Navigate, Outlet } from 'react-router-dom'
import React, { useEffect, useState } from 'react'
import UnlockPage from '../components/UnlockPage'
import { useAppSelector } from '../hooks/redux'
import { selectAccessToken, selectRegisterInfo } from '../redux/slices/authSlice'
import { selectMnemonic, selectRawMnemonic } from '../redux/slices/accountSlice'

function HomeLayout() {

    // State
    const [lockModal, setLockModal] = useState(false)

    // Redux
    const registerInfo = useAppSelector(selectRegisterInfo)
    const mnemonic = useAppSelector(selectMnemonic)
    const rawMnemonic = useAppSelector(selectRawMnemonic)
    const accessToken = useAppSelector(selectAccessToken)

    useEffect(() => {
        if (!rawMnemonic) {
            setLockModal(true)
        }
    }, [rawMnemonic])

    if (
        (!registerInfo.nationalCode && !registerInfo.phoneNumber) ||
        !accessToken
    )
        return <Navigate to="/auth/login" />

    if (!mnemonic) return <Navigate to="/account" />

    return lockModal ? (
            <UnlockPage
                open={lockModal}
                handleClose={() => setLockModal((prev) => !prev)}
            />
        ) : <Outlet />
}

export default HomeLayout;
